import request from '../http/request'
// 获取字典数据
export function getDictList (params) {
  return request({
    url: '/dict/getSysDictDataList', // 请求地址 dict/getDictList
    method: 'GET', // 请求方式
    params // 参数
  })
}
// 发送短信验证码
export function onSendSms (data) {
  return request({
    url: '/common/smsVerificationCode', // 请求地址
    method: 'POST', // 请求方式
    data // 参数
  })
}
// 登录
export function chnEngLoginRequest (data) {
  return request({
    url: '/mobileLoginErp',
    method: 'POST',
    data
  })
}
// 退出登录
export function loginOutRequest (params) {
  return request({
    url: '/loginOut',
    method: 'GET',
    params
  })
}
// 获取用户信息列表
export function getSysUserList (params) {
  return request({
    url: '/erpUser/getSysUserList',
    method: 'GET',
    params
  })
}
// 获取用户详情信息
export function getSysUserInfo (params) {
  return request({
    url: '/erpUser/getSysUserInfo',
    method: 'GET',
    params
  })
}
// 新增用户（手机号）
export function fastAddSysUser (data) {
  return request({
    url: '/erpUser/fastAddSysUser',
    method: 'POST',
    data
  })
}

// 获取赛区信息列表
export function queryDistrictPage (params) {
  return request({
    // url: '/erp/district/queryDistrictPage',
    url: '/district/queryDistrictPage',
    method: 'GET',
    params
  })
}
// 获取赛区考场列表

export function queryExaminationList (params) {
  return request({
    url: '/common/examination/queryExaminationList',
    method: 'GET',
    params
  })
}
// 获取申请考量的学校列表
export function getApplySchool (params) {
  return request({
    url: '/paper/getApplySchool',
    method: 'GET',
    params
  })
}
// 查询学校列表
export function getSchoolList (params) {
  return request({
    url: '/school/getSysSchoolList',
    method: 'GET',
    params
  })
}
// 获取地址列表
export function getSysUserAddressListByUserId (params) {
  return request({
    url: '/address/getSysUserAddressListByUserId',
    method: 'GET',
    params
  })
}

// 根据省市区查询学校
export function getSchoolListWithCity (params) {
  return request({
    url: '/school/getSchoolList',
    method: 'GET',
    params
  })
}
// 保存用户信息
export function saveSysUserAll (data) {
  return request({
    url: '/erpUser/saveSysUserAll',
    method: 'POST',
    data
  })
}
// erp 查询学校列表
export function getSysSchoolList (params) {
  return request({
    url: '/school/getSysSchoolList',
    method: 'GET',
    params
  })
}
// 保存学校信息
export function addSysSchool (data) {
  return request({
    url: '/school/addSysSchool',
    method: 'POST',
    data
  })
}
// 查询学校审核列表
export function getApproveSchoolList (params) {
  return request({
    url: '/school/getApproveSchoolList',
    method: 'GET',
    params
  })
}
// 批量生成学校参赛码
export function createSchoolUniqueCode (params) {
  return request({
    url: '/school/createSchoolUniqueCode',
    method: 'GET',
    params
  })
}
// 学校审核状态操作
export function approveSchoolTeacher (data) {
  return request({
    url: '/school/approveSchoolTeacher',
    method: 'POST',
    data
  })
}
// 查询字库相关列表
export function queryOpenProductList (params) {
  return request({
    url: '/openProduct/queryOpenProductList',
    method: 'GET',
    params
  })
}
// 保存用户开通字库
export function addOpenProductList (data) {
  return request({
    url: '/openProduct/addOpenProductList',
    method: 'POST',
    data
  })
}
// 查询学校试卷申请列表
export function getPaperApplyList (params) {
  return request({
    url: '/paper/getPaperApplyList',
    method: 'GET',
    params
  })
}
// 审核学校试卷申请
export function processPaperApply (data) {
  return request({
    url: '/paper/processPaperApply',
    method: 'POST',
    data
  })
}
// 获取学校试卷申请详情
export function queryPersonalPaperApplyInfo (params) {
  return request({
    url: '/paper/queryPersonalPaperApplyInfo',
    method: 'GET',
    params
  })
}
// 审核学校试卷申请
export function paperApplyExpressDelivery (data) {
  return request({
    url: '/paper/paperApplyExpressDelivery',
    method: 'POST',
    data
  })
}
// 变更试卷状态
export function updatePaperStatusDTO (data) {
  return request({
    url: '/paper/updatePaperStatusDTO',
    method: 'POST',
    data
  })
}
// 获取code列表
export function queryConversionCodeList (params) {
  return request({
    url: '/code/queryConversionCodeList',
    method: 'GET',
    params
  })
}
// 获取海外code列表
export function queryOverseasConversionCodeList (params) {
  return request({
    url: '/overseasMatchCode/queryConversionCodeList',
    method: 'GET',
    params
  })
}
// 添加海外code
export function addOverseasConversionCode (data) {
  return request({
    url: '/overseasMatchCode/addConversionCode',
    method: 'POST',
    data
  })
}
// 修改是否使用海外code
export function updateOverseasConversionCode (data) {
  return request({
    url: '/overseasMatchCode/updateAllocation',
    method: 'POST',
    data
  })
}
// 新增产品解锁码
export function addConversionCode (data) {
  return request({
    url: '/code/addConversionCode',
    method: 'POST',
    data
  })
}

// 新增产品兑换码码
export function addConversionCodeV2 (data) {
  return request({
    url: '/code/addConversionCodeV2',
    method: 'POST',
    data
  })
}

// 获取订单列表
export function getTbOrderList (params) {
  return request({
    url: '/order/getTbOrderList',
    method: 'GET',
    params
  })
}
// 获取订单详情
export function getTbOrderInfo (params) {
  return request({
    url: '/order/getTbOrderInfo',
    method: 'GET',
    params
  })
}
// 提交快递信息
export function fillInTheTrackingNumber (data) {
  return request({
    url: '/order/fillInTheTrackingNumber',
    method: 'POST',
    data
  })
}
// 确认收货
export function executionOrderCompletion (data) {
  return request({
    url: '/order/executionOrderCompletion',
    method: 'POST',
    data
  })
}
// 获取用户订单
export function queryTbOrderList (params) {
  return request({
    url: '/order/queryTbOrderList',
    method: 'GET',
    params
  })
}
// 根据订单号查询订单下产品
export function queryProductOrderList (params) {
  return request({
    url: '/orderProduct/queryTbOrderList',
    method: 'GET',
    params
  })
}
// 获取报名资格
export function queryTbEnrollmentList (params) {
  return request({
    url: '/enrollment/queryTbEnrollmentList',
    method: 'GET',
    params
  })
}
// 根据赛季和赛程Flag获取赛程信息
export function querySeasonRaceScheduleFlag (params) {
  return request({
    url: '/raceSchedule/querySeasonRaceScheduleFlag',
    method: 'GET',
    params
  })
}
// 获取产品列表
export function getOpenProducts (params) {
  return request({
    url: '/openProduct/getOpenProducts',
    method: 'GET',
    params
  })
}
// 根据产品Id查询产品开通记录
export function queryOpenProductById (data) {
  return request({
    url: '/openProduct/queryOpenProductById',
    method: 'POST',
    data
  })
}

// 批量开通
export function openProducts (data) {
  return request({
    url: '/openProduct/openProducts',
    method: 'POST',
    data
  })
}
// 获取线上考试成绩
export function queryAnswerResultsPage (params) {
  return request({
    url: '/Initial/Reply/queryAnswerResultsPage',
    method: 'GET',
    params
  })
}
// 获取线下考试成绩--初赛
export function queryPaperResultScore (params) {
  return request({
    url: '/Initial/Reply/queryPaperResultScore',
    method: 'GET',
    params
  })
}
// 线下初赛成绩单项新增
export function addInitialReplyScore (data) {
  return request({
    url: '/Initial/Reply/addInitialReplyScore',
    method: 'POST',
    data
  })
}
// 获取线下考试成绩--复赛
export function queryOfflineScores (params) {
  return request({
    url: '/enrollment/queryOfflineScores',
    method: 'GET',
    params
  })
}
// 获取成绩详情
export function getAnswerRaceScheduleByUserId (params) {
  return request({
    url: '/Initial/Reply/getAnswerRaceScheduleByUserId',
    method: 'GET',
    params
  })
}

// 比赛设置晋级
export function replyQueryModelPaperResultScore (data) {
  return request({
    url: '/Initial/Reply/queryModelPaperResultScore',
    method: 'POST',
    data
  })
}
// 线上成绩设置晋级国赛
export function setTbEnrollmentPromotion (data) {
  return request({
    url: '/enrollment/setTbEnrollmentPromotion',
    method: 'POST',
    data
  })
}
// 线上成绩第一轮设置晋级
export function setTbEnrollmentRoundPromotion (data) {
  return request({
    url: '/enrollmentRoundInfo/edit',
    method: 'POST',
    data
  })
}
// 线下成绩设置晋级
export function updateInitialReplyScore (data) {
  return request({
    url: '/Initial/Reply/updateInitialReplyScore',
    method: 'POST',
    data
  })
}
// 线下成绩设置晋级-复赛
export function setFinalsPromotion (data) {
  return request({
    url: '/enrollment/setTbEnrollmentPromotion',
    method: 'POST',
    data
  })
}
// 获取线上晋级预期
export function queryModelPaperExpectResultScore (params) {
  return request({
    url: '/Initial/Reply/queryModelPaperExpectResultScore',
    method: 'GET',
    params
  })
}
// 获取线下晋级预期
export function queryModelExpectInitialReplyScore (params) {
  return request({
    url: '/Initial/Reply/queryModelExpectInitialReplyScore',
    method: 'GET',
    params
  })
}
// 线上批量设置晋级
export function queryModelPaperResultScore (data) {
  return request({
    url: '/Initial/Reply/queryModelPaperResultScore',
    method: 'POST',
    data
  })
}
// 线下批量设置晋级
export function queryModelInitialReplyScore (data) {
  return request({
    url: '/Initial/Reply/queryModelInitialReplyScore',
    method: 'POST',
    data
  })
}

// 一键生成成绩查询码
export function oneKeyGenerateScoreCode (data) {
  return request({
    url: '/Initial/Reply/oneKeyGenerateScoreCode',
    method: 'POST',
    data
  })
}
// 单个生成成绩查询码
export function oneGenerateScoreCode (data) {
  return request({
    url: '/Initial/Reply/oneGenerateScoreCode',
    method: 'POST',
    data
  })
}
// 成绩模板下载
export function importPreliminaryCompetitionTemplate (params) {
  return request({
    url: '/Initial/Reply/importPreliminaryCompetitionTemplate',
    method: 'GET',
    params
  })
}
// 获取赛程时间列表
export function querySeasonRaceSchedule (params) {
  return request({
    url: '/raceSchedule/querySeasonRaceSchedule',
    method: 'GET',
    params
  })
}
// 设置当前赛程相关信息
export function setSeasonRaceSchedule (data) {
  return request({
    url: '/raceSchedule/setSeasonRaceSchedule',
    method: 'POST',
    data
  })
}
// 设置当前正在进行的赛程
export function setSeasonRaceScheduleIng (data) {
  return request({
    url: '/raceSchedule/setSeasonRaceScheduleIng',
    method: 'POST',
    data
  })
}

// ==============字库管理=============
// 获取字库列表
export function getCWordList (params) {
  return request({
    url: '/lexicon/getCWordList',
    method: 'GET',
    params
  })
}
// 删除字
export function deleteCWord (params) {
  return request({
    url: '/lexicon/deleteCWord',
    method: 'DELETE',
    params
  })
}
// 增加or修改字库内容
export function addCWord (data) {
  return request({
    url: '/lexicon/addCWord',
    method: 'POST',
    data
  })
}
// 查询字详情
export function getCWordInfoGroupList (params) {
  return request({
    url: '/lexicon/getCWordInfoById',
    method: 'GET',
    params
  })
}
// 新增赛区
export function saveOrUpdateDistrict (data) {
  return request({
    url: '/district/saveOrUpdateDistrict',
    method: 'POST',
    data
  })
}
// 查询erp列表用户
export function queryErpUserList (params) {
  return request({
    url: '/erp/queryErpUserList',
    method: 'GET',
    params
  })
}
// 获取赛区事件列表
export function queryDistrictTimePage (params) {
  return request({
    url: '/erp/districtTime/v1/queryDistrictTimePage',
    method: 'GET',
    params
  })
}
// 保存或修改赛区时间
export function saveOrUpdateDistrictTime (data) {
  return request({
    url: '/erp/districtTime/v1/saveOrUpdateDistrictTime',
    method: 'POST',
    data
  })
}
// 删除赛区时间
export function deleteDistrictTime (params) {
  return request({
    url: '/erp/districtTime/v1/deleteDistrictTime',
    method: 'GET',
    params
  })
}
// 获取课程产品列表
export function getTbProductListInfoPage (params) {
  return request({
    url: '/lexicon/getTbProductListInfoPage',
    method: 'GET',
    params
  })
}
// 删除课程
export function deleteProductInfo (data) {
  return request({
    url: '/lexicon/deleteProductInfo',
    method: 'POST',
    data
  })
}
// 下架处理
export function updateTakeOffTheShelf (data) {
  return request({
    url: '/lexicon/updateTakeOffTheShelf',
    method: 'POST',
    data
  })
}

// 获取课程二级联动类型
export function secondaryLinkageCourseQuery (data) {
  return request({
    url: '/lexicon/secondaryLinkageCourseQuery',
    method: 'POST',
    data
  })
}

// 新增课程产品
export function addTbProductListInfo (data) {
  return request({
    url: '/lexicon/addTbProductListInfo',
    method: 'POST',
    data
  })
}
// 获取课程详情
export function queryTbProductListInfo (params) {
  return request({
    url: '/lexicon/queryTbProductListInfo',
    method: 'GET',
    params
  })
}
// 根据学校获取学校下的老师
export function getSchoolTeacherList (params) {
  return request({
    url: '/school/getSchoolTeacherList',
    method: 'GET',
    params
  })
}

// 学校开通课程
export function addTbProductSchoolList (data) {
  return request({
    url: '/openProduct/addTbProductSchoolList',
    method: 'POST',
    data
  })
}
// 查询学校开通了哪些课程
export function queryProductSchoolList (params) {
  return request({
    url: '/openProduct/queryProductSchoolList',
    method: 'GET',
    params
  })
}
// 添加社团课老师信息
export function addSchoolTeacherOrganization (data) {
  return request({
    url: '/school/addSchoolTeacherOrganization',
    method: 'POST',
    data
  })
}
// 下载喜报模板
export function downLoad (params) {
  return request({
    url: '/goodNews/downLoad',
    method: 'GET',
    params
  })
}
// 导入喜报模板
export function importExcel (data) {
  return request({
    url: '/goodNews/importExcel',
    method: 'POST',
    data
  })
}
// 社团管理，编辑授课老师信息
export function updateSchoolTeacher (data) {
  return request({
    url: '/school/updateSchoolTeacher',
    method: 'POST',
    data
  })
}

// 删除社团老师课程
export function deleteSchoolTeacher (data) {
  return request({
    url: '/school/deleteSchoolTeacher',
    method: 'POST',
    data
  })
}

// 解封和禁用教师课程
export function disableSchoolTeacher (data) {
  return request({
    url: '/school/disableSchoolTeacher',
    method: 'POST',
    data
  })
}

// 线上线下成绩修改
export function updateTbEnrollmentIsOnline (data) {
  return request({
    url: '/enrollment/updateTbEnrollmentIsOnline',
    method: 'POST',
    data
  })
}
// 重置选手线上初复赛成绩
export function resetPlayerScore (data) {
  return request({
    url: '/reset/resetPlayerScore',
    method: 'POST',
    data
  })
}

// 查询线下考场考位
export function queryExaminationListPage (params) {
  return request({
    url: '/examination/queryExaminationListPage',
    method: 'GET',
    params
  })
}
// 获取考场通用信息
export function queryExaminationRoomInfo (params) {
  return request({
    url: '/examination/queryExaminationRoomInfo',
    method: 'GET',
    params
  })
}

// 保存考场通用信息
export function addExaminationRoomInfo (data) {
  return request({
    url: '/examination/addExaminationRoomInfo',
    method: 'POST',
    data
  })
}

// 设置是否开放考场
export function setExaminationTestPosition (data) {
  return request({
    url: '/examination/setExaminationTestPosition',
    method: 'POST',
    data
  })
}

// 保存或修改考场
export function updateExaminationRoom (data) {
  return request({
    url: '/examination/updateExaminationRoom',
    method: 'POST',
    data
  })
}
// 查询考场内的学生
export function queryExaminationUserListPage (params) {
  return request({
    url: '/examinationUser/queryExaminationUserListPage',
    method: 'GET',
    params
  })
}
// 重置考场内所有学生
export function resetAllUser (examinationId) {
  return request({
    url: `/examinationUser/removeExaminationRoomAllUser/${examinationId}`,
    method: 'POST'
  })
}
// 重置考场内的某个学生
export function resetSingleUser (id) {
  return request({
    url: `/examinationUser/removeExaminationRoomUser/${id}`,
    method: 'POST'
  })
}
// 个人赛赛务管理-首页
// 个人赛赛程-统计人数
export function individualScheduleStatistics (params) {
  return request({
    url: '/homePage/individualScheduleStatistics',
    method: 'GET',
    params
  })
}
// 数据统计
export function dataStatistics (params) {
  return request({
    url: '/homePage/dataStatistics',
    method: 'GET',
    params
  })
}
// 待处理事务
export function pendingMatter (params) {
  return request({
    url: '/homePage/pendingMatter',
    method: 'GET',
    params
  })
}
// 个人赛考务管理-首页
// 个人赛成绩查询（本赛季）
export function competitionStatisticsBySeason (params) {
  return request({
    url: '/examination/competitionStatisticsBySeason',
    method: 'GET',
    params
  })
}
// 历史成绩查询
export function historicalCompetitionStatistics (params) {
  return request({
    url: '/examination/historicalCompetitionStatistics',
    method: 'GET',
    params
  })
}
// 个人赛参赛人数统计
export function competitionBySeason (params) {
  return request({
    url: '/examination/competitionBySeason',
    method: 'GET',
    params
  })
}
// 历史参赛人数统计
export function historicalGameStatistics (params) {
  return request({
    url: '/examination/historicalGameStatistics',
    method: 'GET',
    params
  })
}
// 订单概览
export function historicalProductStatistics (params) {
  return request({
    url: '/product/historicalProductStatistics',
    method: 'GET',
    params
  })
}
// 退款-查看退款-退货退款审核
export function orderRefundReviewInfo (params) {
  return request({
    url: '/orderRefund/orderRefundReviewInfo',
    method: 'GET',
    params
  })
}
export function refundRecordInfo (params) {
  return request({
    url: '/refundRecord/info',
    method: 'GET',
    params
  })
}

// 退款-查看退款列表
export function orderRefundReviewList (params) {
  return request({
    url: '/refundRecord/page',
    method: 'GET',
    params
  })
}
// 退款审批
export function refundRecordReview (data) {
  return request({
    url: '/refundRecord/review',
    method: 'POST',
    data
  })
}
// 修改退款金额
export function changeOrderPrice (data) {
  return request({
    url: '/refundRecord/updateRefundProce',
    method: 'POST',
    data
  })
}

// 退款-审核退款-退货退款
export function orderRefundReview (data) {
  return request({
    url: '/orderRefund/orderRefundReview',
    method: 'POST',
    data
  })
}
// 退款订单-确认/拒绝收货
export function sellerConfirmsReceiptOfGoods (data) {
  return request({
    url: '/orderRefund/sellerConfirmsReceiptOfGoods',
    method: 'POST',
    data
  })
}
// 退款-财务打款
export function financialAuditRefund (data) {
  return request({
    url: '/orderRefund/financialAuditRefund',
    method: 'POST',
    data
  })
}

// 导出考场模版
export function excelTemplatesTheSemiFinals (params) {
  return request({
    url: '/examination/excelTemplatesTheSemiFinals',
    method: 'GET',
    params
  })
}
// 导入考场
export function importTemplatesTheSemiFinals (data) {
  return request({
    url: '/examination/importTemplatesTheSemiFinals',
    method: 'POST',
    data
  })
}

// 参赛码
export function queryFormMatchListPage (params) {
  return request({
    url: '/form/queryFormMatchListPage',
    method: 'GET',
    params
  })
}

// 修改参赛码 /form/saveFormMatch

export function saveFormMatch (url, data) {
  return request({
    url,
    method: 'POST',
    data
  })
}

// 查询线上答题
export function queryTheOnlineFormAnswer (params) {
  return request({
    url: '/form/queryTheOnlineFormAnswer',
    method: 'GET',
    params
  })
}

// 表单答题系统信息匹配
export function oneClickMatchingFunction (data) {
  return request({
    url: '/form/oneClickMatchingFunction',
    method: 'POST',
    data
  })
}

// 修改个人资料
export function updateTheOnlineFormAnswerInfo (data) {
  return request({
    url: '/form/updateTheOnlineFormAnswerInfo',
    method: 'POST',
    data
  })
}

// 查询账户列表
export function getAccount (params) {
  return request({
    url: '/erp/queryErpUserList',
    method: 'GET',
    params
  })
}
// 修改账户信息
export function addAccount (data) {
  return request({
    url: '/erp/addErpUserList',
    method: 'POST',
    data
  })
}
// 删除账户
export function delAccount (params) {
  return request({
    url: '/erp/deleteErpUser',
    method: 'GET',
    params
  })
}

// 查询字典类型
export function getDictTypeList (params) {
  return request({
    url: '/dict/getSysDictTypeList',
    method: 'GET',
    params
  })
}
// 添加/修改字典类型
export function addSysDictType (data) {
  return request({
    url: '/dict/addSysDictType',
    method: 'POST',
    data
  })
}

// 根据type类型从缓存查询字典表
export function getSysDictDataList (params) {
  return request({
    url: '/dict/getSysDictDataList',
    method: 'GET',
    params
  })
}
// 添加字典数据
export function addSysDictTypeValue (data) {
  return request({
    url: '/dict/addSysDictTypeValue',
    method: 'POST',
    data
  })
}
// 查询本组别未选择考场【线下-线上】学生
export function queryUnselectedRoomUserList (params) {
  return request({
    url: '/examinationUser/queryUnselectedRoomUserList',
    method: 'GET',
    params
  })
}
// 批量添加
export function batchExaminationRoom (data) {
  return request({
    url: '/examinationUser/batchExaminationRoom',
    method: 'POST',
    data
  })
}
// 修改参赛资格组别和年级
export function updateTbEnrollmentGroup (data) {
  return request({
    url: '/enrollment/updateTbEnrollmentGroup',
    method: 'POST',
    data
  })
}
// 标签-查询系统预设标签
export function queryWordTagList (params) {
  return request({
    url: '/sWord/queryWordTagList',
    method: 'GET',
    params
  })
}

// 标签-分页列表
export function queryWordTagInfoList (params) {
  return request({
    url: '/sWord/queryWordTagInfoList',
    method: 'GET',
    params
  })
}

// 添加|修改标签
export function updateWordTagInfoList (data) {
  return request({
    url: '/sWord/updateWordTagInfoList',
    method: 'POST',
    data
  })
}

// 删除标签
export function deleteWordTagInfoList (id) {
  return request({
    url: `/sWord/deleteWordTagInfoList/${id}`,
    method: 'DELETE'
  })
}
// 查询英文参赛选手列表
export function queryNationEngPage (params) {
  return request({
    url: '/national/queryNationEngPage',
    method: 'GET',
    params
  })
}
// 保存修改英文参赛选手信息
export function updateNationEngPage (data) {
  return request({
    url: '/national/updateNationEngPage',
    method: 'POST',
    data
  })
}
// 国赛列表
export function queryTbEnrollmentNationalList (params) {
  return request({
    url: '/enrollment/queryTbEnrollmentNationalList',
    method: 'GET',
    params
  })
}
// 查看缴费详情
export function queryNationalFeesInfo (params) {
  return request({
    url: '/national/queryNationalFeesInfo',
    method: 'GET',
    params
  })
}

// 账号管理
// 修改用户erp状态
export function updateState (data) {
  return request({
    url: '/erp/updateState',
    method: 'POST',
    data
  })
}
// 获取系统用户列表
export function getQueryErpUserList (params) {
  return request({
    url: '/erp/queryErpUserList',
    method: 'GET',
    params
  })
}
// 修改用户身份
export function erpEditSysUserIdentity (data) {
  return request({
    url: '/erpSysUserIdentity/edit',
    method: 'POST',
    data
  })
}
// 删除用户身份
export function erpDeleteSysUserIdentity (data) {
  return request({
    url: '/erpSysUserIdentity/delete',
    method: 'DELETE',
    data
  })
}
// 获取用户下的身份列表
export function getSysUserIdentityList (params) {
  return request({
    url: '/erpSysUserIdentity/list',
    method: 'GET',
    params
  })
}
// 新增系统用户信息
export function addSystemUser (data) {
  return request({
    url: '/erp/add',
    method: 'POST',
    data
  })
}
// 修改系统用户信息
export function editSystemUser (data) {
  return request({
    url: '/erp/edit',
    method: 'POST',
    data
  })
}
// 查询系统用户详情
export function getSysUserinfo (id) {
  return request({
    url: `/erp/info/${id}`,
    method: 'GET'
  })
}
// 获取部门列表
export function getSectionList (params) {
  return request({
    url: '/dept/tree',
    method: 'GET',
    params
  })
}
// 获取岗位列表不分页
export function getRoleListData (params) {
  return request({
    url: '/role/list',
    method: 'GET',
    params
  })
}
// 添加用户身份
export function erpSysUserIdentityCreate (data) {
  return request({
    url: '/erpSysUserIdentity/create',
    method: 'POST',
    data
  })
}
// 权限
// 获取菜单树形图
export function getSysMenuTreeData (params) {
  return request({
    url: '/menu/tree',
    method: 'GET',
    params
  })
}
// 创建菜单
export function creatSysMenuTreeData (data) {
  return request({
    url: '/menu/create',
    method: 'POST',
    data
  })
}
// 删除菜单
export function deleteSysMenuTreeData (data) {
  return request({
    url: '/menu/delete',
    method: 'DELETE',
    data
  })
}
// 编辑菜单
export function editSysMenuTreeData (data) {
  return request({
    url: '/menu/edit',
    method: 'POST',
    data
  })
}
// 日志
// 获取所有日志
export function getAllLogsList (params) {
  return request({
    url: '/sysLog/page',
    method: 'GET',
    params
  })
}

// 获取岗位列表
export function getRoleList (params) {
  return request({
    url: '/role/page',
    method: 'GET',
    params
  })
}
// 新建岗位
export function creatRoleData (data) {
  return request({
    url: '/role/create',
    method: 'POST',
    data
  })
}
// 修改岗位
export function editRoleData (data) {
  return request({
    url: '/role/edit',
    method: 'POST',
    data
  })
}
// 删除岗位
export function deleteRoleinfo (id) {
  return request({
    url: `/role/delete/${id}`,
    method: 'DELETE'
  })
}
// 获取树形权限包括已分配
export function getSelectMenuTreeData (params) {
  return request({
    url: '/roleMenu/tree',
    method: 'GET',
    params
  })
}
// 保存分配权限
export function saveSysMenuTreeData (data) {
  return request({
    url: '/roleMenu/allocation',
    method: 'POST',
    data
  })
}
// 编辑部门信息
export function editDeptData (data) {
  return request({
    url: '/dept/edit',
    method: 'POST',
    data
  })
}
// 删除部门信息
export function deleteSysUserinfo (id) {
  return request({
    url: `/dept/delete/${id}`,
    method: 'DELETE'
  })
}

// 添加部门
export function createDeptData (data) {
  return request({
    url: '/dept/create',
    method: 'POST',
    data
  })
}
// 获取赛区信息列表（无限制）
export function queryAllDistrictPage (params) {
  return request({
    url: '/district/all',
    method: 'GET',
    params
  })
}
// 获取部门下的赛区
export function getDeptDistrict (params) {
  return request({
    url: '/dept/getDeptDistrict',
    method: 'GET',
    params
  })
}
// 保存部门下的赛区
export function saveEditDistrict (data) {
  return request({
    url: '/dept/editDistrict',
    method: 'POST',
    data
  })
}

// 获取用户身份列表
export function listByLogin (params) {
  return request({
    url: '/erpSysUserIdentity/listByLogin',
    method: 'GET',
    params
  })
}

// 设置当前登录身份
export function setIdentity (params) {
  return request({
    url: '/erp/setIdentity',
    method: 'GET',
    params
  })
}

// 新增国赛考场
export function nationalExamCreate (data) {
  return request({
    url: '/en/create',
    method: 'POST',
    data
  })
}
// 修改国赛考场
export function nationalExamEdit (data) {
  return request({
    url: '/en/edit',
    method: 'POST',
    data
  })
}

// 获取考场列表
export function nationalQueryExaminationListPage (params) {
  return request({
    url: '/en/queryExaminationListPage',
    method: 'GET',
    params
  })
}

// 重置选手考场信息
export function removeExaminationRoomUser (data) {
  return request({
    url: '/en/removeExaminationRoomUser',
    method: 'POST',
    data
  })
}
// 重置选手信息（手机号）
export function removeExaminationRoomUseByPhone (data) {
  return request({
    url: '/en/removeExaminationRoomUseByPhone',
    method: 'POST',
    data
  })
}

// 修改考场状态
export function setNationalExamStatue (data) {
  return request({
    url: '/en/setStatue',
    method: 'POST',
    data
  })
}

// 获取选手列表
export function getNationalSpellerList (params) {
  return request({
    url: '/en/sitList',
    method: 'GET',
    params
  })
}

// 新增选手
export function addNationalUser (data) {
  return request({
    url: '/en/addUser',
    method: 'POST',
    data
  })
}

// 获取资格赛比赛信息
export function getExamRoomMatchInfo (params) {
  return request({
    url: '/en/getExamRoomMatchInfo',
    method: 'GET',
    params
  })
}

// 保存比赛信息
export function nationalSaveScores (data) {
  return request({
    url: '/en/saveScores',
    method: 'POST',
    data
  })
}

// 修改国赛资格晋级状态
export function updateNationalPromotion (data) {
  return request({
    url: '/en/updatePromotion',
    method: 'POST',
    data
  })
}

// 导出全部比赛信息
export function exportNationalScore (params) {
  return request({
    url: '/en/exportScore',
    method: 'GET',
    params
  })
}

// 全国总查询比赛所有轮次
export function setCityFinalRoundFinal (params) {
  return request({
    url: '/nationalMatch/selectRound',
    method: 'GET',
    params
  })
}
// 全国总查询晋级人数
export function getPromotionNumFinal (params) {
  return request({
    url: '/nationalMatch/getPromotionNum',
    method: 'GET',
    params
  })
}
// 全国总设置晋级人数
export function citySetPromotionNumFinal (data) {
  return request({
    url: '/nationalMatch/setPromotionNum',
    method: 'POST',
    data
  })
}
// 全国总设置晋级
export function citySetPromotionFinal (data) {
  return request({
    url: '/nationalMatch/citySetPromotion',
    method: 'POST',
    data
  })
}
// 全国总查询轮次下选手
export function selectUserByRoundFinal (params) {
  return request({
    url: '/nationalMatch/selectUserByRound',
    method: 'GET',
    params
  })
}
// 全国总回退上一轮次
export function resetMatchFinal (data) {
  return request({
    url: '/nationalMatch/matchBack',
    method: 'POST',
    data
  })
}
// 国赛重置所有轮次
export function resettingFinal (data) {
  return request({
    url: '/nationalMatch/resetting',
    method: 'POST',
    data
  })
}
// 国赛查看实时排名
export function getMatchWinnersFinal (params) {
  return request({
    url: '/nationalMatch/matchWinners',
    method: 'GET',
    params
  })
}
// 查看签到选手列表
export function getSignInList (params) {
  return request({
    url: '/enrollment/getSignInList',
    method: 'GET',
    params
  })
}
// 国赛单项设置晋级
export function setPromotionPointFinal (data, hiddenLoad) {
  return request({
    url: '/nationalMatch/setPromotion',
    method: 'POST',
    hiddenLoad: hiddenLoad,
    data
  })
}
// 国赛并列晋级
export function setAbreastPromotionFinal (data) {
  return request({
    url: '/nationalMatch/setAbreastPromotion',
    method: 'POST',
    data
  })
}
// 获取国赛赛淘汰排名
export function getPromotionRankingFinal (params) {
  return request({
    url: '/nationalMatch/getPromotionRanking',
    method: 'GET',
    params
  })
}
// 国赛无组别开始比赛
export function nationalStart (data) {
  return request({
    url: '/nationalMatch/nationalStart',
    method: 'POST',
    data
  })
}
// 国赛无组别设置晋级
export function nationalNoGroupSetPromotion (data) {
  return request({
    url: '/nationalMatch/nationalNoGroupSetPromotion',
    method: 'POST',
    data
  })
}

// 获取小程序轮播图
export function bannerList (data) {
  return request({
    url: '/banner/list',
    method: 'POST',
    data
  })
}
// 删除小程序banner
export function bannerDelete (data) {
  return request({
    url: '/banner/delete',
    method: 'DELETE',
    data
  })
}

export function getCountryList (params) {
  return request({
    url: '/common/countryList',
    method: 'GET',
    params
  })
}

export function fastAddSysUserByEmail (data) {
  return request({
    url: '/erpUser/fastAddSysUserByEmail',
    method: 'POST',
    data
  })
}

// 查询海外B端用户绑定赛区
export function queryOverseasUserDistrictList (params) {
  return request({
    url: '/overseasUserDistrict/queryOverseasUserDistrictList',
    method: 'GET',
    params
  })
}

// 添加海外B端用户绑定赛区
export function addOverseasUserDistrict (data) {
  return request({
    url: '/overseasUserDistrict/addOverseasUserDistrict',
    method: 'POST',
    data
  })
}

// 删除海外code
export function deleteOverseasConversionCode (data) {
  return request({
    url: '/overseasMatchCode/delete',
    method: 'DELETE',
    data
  })
}
// 禁用海外code
export function disableOverseasConversionCode (data) {
  return request({
    url: '/overseasMatchCode/updateState',
    method: 'POST',
    data
  })
}
// 获取海外申请参赛码数据
export function getOverseasApplyCodeList (params) {
  return request({
    url: '/overseasMatchCode/applyList',
    method: 'GET',
    params
  })
}
// 审核海外申请参赛码
export function auditOverseasApplyCode (data) {
  return request({
    url: '/overseasMatchCode/review',
    method: 'POST',
    data
  })
}

// 获取海外组委会申请信息
export function getOverseasCommitteeApplyforList (params) {
  return request({
    url: '/overseasCommitteeApply/selectList',
    method: 'GET',
    params
  })
}

// 审核海外组委会申请信息
export function auditOverseasCommitteeApplyfor (data) {
  return request({
    url: '/overseasCommitteeApply/review',
    method: 'POST',
    data
  })
}

// C端提交报名全球比赛的信息
export function sunbmitNationalShipFrees (data) {
  return request({
    url: '/overseasMatchCode/sunbmitNationalShipFrees',
    method: 'POST',
    data
  })
}

// B端查询组委会绑定的管理账号
export function queryOverseasCommitteeAdminList (data) {
  return request({
    url: '/overseasUserDistrict/queryOverseasUserByDistrict',
    method: 'POST',
    data
  })
}

// 导出考场模版
export function excelTemplatesThePaperData (params) {
  return request({
    url: '/paper/exportPaperApplyList',
    method: 'GET',
    params
  })
}

// 获取教师子女列表
export function getTeacherChildList (params) {
  return request({
    url: '/sysTeacherChildren/page',
    method: 'GET',
    params
  })
}

// 删除教师子女
export function deleteTeacherChild (data) {
  return request({
    url: '/sysTeacherChildren/delete',
    method: 'POST',
    data
  })
}
// 新增教师子女
export function addTeacherChild (data) {
  return request({
    url: '/sysTeacherChildren/add',
    method: 'POST',
    data
  })
}
// 编辑教师子女
export function editTeacherChild (data) {
  return request({
    url: '/sysTeacherChildren/edit',
    method: 'POST',
    data
  })
}
// 获取教师子女详情
export function getTeacherChildInfo (params) {
  return request({
    url: '/sysTeacherChildren/info',
    method: 'GET',
    params
  })
}

// 获取所有学校列表信息
export function getAllSchoolList (params) {
  return request({
    url: 'common/getSchoolList',
    method: 'GET',
    params
  })
}
